import React from 'react';

import { PromotionSectionCard } from './PromotionSectionCard';
import { TextInput } from '../../component/TextInput';

export function ToastSection({
  toastTitle,
  setToastTitle,
  toastBody,
  setToastBody,
}: {
  toastTitle: string;
  setToastTitle: (v: string) => void;
  toastBody: string;
  setToastBody: (v: string) => void;
}) {
  return (
    <PromotionSectionCard>
      <h2>
        Toast Message <span className="text-xs">(Optional)</span>
      </h2>
      <p className="text-xs text-gray-500 font-normal mb-2">
        Customer-facing message to be displayed upon each successful login into the customer portal
        when they have a free promotional product on an upcoming order.
      </p>

      <div className="w-full mb-2">
        <h3 className="flex">Title Text</h3>
        <TextInput
          placeholder="Optional toast message title text"
          value={toastTitle}
          setTextChange={setToastTitle}
        />
      </div>

      <div className="w-full mb-2">
        <h3 className="flex">Body Text</h3>
        <TextInput
          placeholder="Optional toast message body text"
          value={toastBody}
          setTextChange={setToastBody}
        />
      </div>
    </PromotionSectionCard>
  );
}
